<template lang="pug">
  .promobanner
    carousel(
      :perPage="1", 
      :loop="true", 
      :navigationEnabled="true", 
      :paginationEnabled="false", 
      :adjustableHeight="false", 
      :autoplay="true", 
      :autoplayTimeout="3500"
    )
      //- slide
      //-   .promobanner--slide.go-prelaunch
      slide
        .promobanner--slide.bursa-fm
          a.promobanner--link(href="//www.bursamarketplace.com/fm70/asset-files/tnc-2.pdf" target="_blank")
      slide
        .promobanner--slide.axa-smartdrive
          a.promobanner--link(href="//w12.financial-link.com.my/PremiumLink3/login?compcode=07&pagePurpose=QUO&agtcode=41407" target="_blank")
      slide
        .promobanner--slide.cs
      slide
        .promobanner--slide.fpx
          router-link(to="/payment/guide", class="promobanner--link")
      slide
        .promobanner--slide.axa
          a.promobanner--link(href="//www.axa.com.my/buy/online-medical-card-malaysia/purchase?id=KWgdrS12yW" target="_blank")
</template>


<script>
  import { mapState } from 'vuex';

  import { Carousel, Slide } from 'vue-carousel';

  import requestHandlers from '../mixins/requestHandlers';

  export default {
    mixins: [requestHandlers],

    components: { 
      Carousel, 
      Slide
    },

    computed: {
      ...mapState('auth', [
        'currentUser'
      ]),

      isDisplayGoBanner() {
        let nf2fCallAction = this.currentUser.nf2fCallAction || 0;
        return nf2fCallAction === 0 || nf2fCallAction === 1;
      },
    }
  }
</script>



<style lang="scss">
  .promobanner {
    background: #000;
    box-shadow: 0 1px 10px rgba(0,0,0,0.15);
  }

  .promobanner--slide {
    position: relative;
    height: 0;
    width: 100%;
    padding-bottom: 26.6667%;

    @include MQ(SM) {
      padding-bottom: 76.823%;
    }

    &.go-prelaunch {
      background: transparent url('../assets/images/carousel-banners/go_prelaunch.jpg') no-repeat center center;
      background-size: cover;

      @include MQ(SM) {
        background: transparent url('../assets/images/carousel-banners/go_prelaunch_sm.jpg') no-repeat center center;
        background-size: cover;
      }
    }

    &.bursa-fm {
      background: transparent url('../assets/images/carousel-banners/bursa-fm.jpg') no-repeat center center;
      background-size: cover;

      @include MQ(SM) {
        background: transparent url('../assets/images/carousel-banners/bursa-fm_sm.jpg') no-repeat center center;
        background-size: cover;
      }
    }

    &.axa-smartdrive {
      background: transparent url('../assets/images/carousel-banners/axa-smartdrive.jpg') no-repeat center center;
      background-size: cover;

      @include MQ(SM) {
        background: transparent url('../assets/images/carousel-banners/axa-smartdrive_sm.jpg') no-repeat center center;
        background-size: cover;
      }
    }


    &.cs {
      background: transparent url('../assets/images/carousel-banners/cs.jpg') no-repeat center center;
      background-size: cover;

      @include MQ(SM) {
        background: transparent url('../assets/images/carousel-banners/cs_sm.jpg') no-repeat center center;
        background-size: cover;
      }
    }

  
    &.fpx {
      background: transparent url('../assets/images/carousel-banners/fpx.jpg') no-repeat center center;
      background-size: cover;

      @include MQ(SM) {
        background: transparent url('../assets/images/carousel-banners/fpx_sm.jpg') no-repeat center center;
        background-size: cover;
      }
    }

    &.axa {
      background: transparent url('../assets/images/carousel-banners/axa.jpg') no-repeat center center;
      background-size: cover;

      @include MQ(SM) {
        background: transparent url('../assets/images/carousel-banners/axa_sm.jpg') no-repeat center center;
        background-size: cover;
      }
    }

  }

  .promobanner--link {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
  }

  // Vue Carousel plugins override
  .promobanner .VueCarousel-navigation-button {
    background: rgba(0, 0, 0, 0.3) !important;
    color: #fff !important;
    height: 40px !important;
    width: 40px !important;
    line-height: 40px !important;
    padding: 0 0 !important;
    border-radius: 50%;
    outline: none !important;

    &.VueCarousel-navigation-prev {
      left: 60px !important;
    }

    &.VueCarousel-navigation-next {
      right: 60px !important;
    }
  }
</style>